export function isTagSort(v) {
    return v === "most" || v === "least" || v === "alpha";
}
/** Returns a new array sorted by the given order; does not mutate the input. */
export function sortTags(tags, order) {
    const copy = tags.slice();
    if (order === "alpha") {
        copy.sort((a, b) => a.name.localeCompare(b.name));
    }
    else if (order === "least") {
        copy.sort((a, b) => (a.count ?? 0) - (b.count ?? 0) || a.name.localeCompare(b.name));
    }
    else {
        copy.sort((a, b) => (b.count ?? 0) - (a.count ?? 0) || a.name.localeCompare(b.name));
    }
    return copy;
}
